module.exports = __webpack_public_path__ + "img/file-code.d786581c.svg";